import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { confirmationEmailSchema, parseZodErrors } from '@utils';
import { useDrainsStore } from '../../../../hooks/useDrainsStore';
import { BinaryOptionType } from '@shared/types';

const pageTitle = 'Do you want a confirmation email of your report?';

export const EmailConfirmation = () => {
  const { data, get, update } = useDrainsStore();
  const navigate = useNavigate();

  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChange = (value: string) => {
    update('wantConfirmationEmail', value as BinaryOptionType);
    setErrorMessages([]);
  };

  const handleNext = () => {
    try {
      const wantConfirmationEmail = get('wantConfirmationEmail');
      confirmationEmailSchema().parse({
        receiveConfirmationEmail: wantConfirmationEmail,
      });
      navigate(RoutesList.CONTACT_USER_OPTION);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);

      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
          message: 'Select if you want to receive a confirmation email',
        })),
      );
    }
  };

  const buttonNext = {
    label: 'Next',
    onClick: handleNext,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.LOCATION_ADDITIONAL_INFORMATION),
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: data?.wantConfirmationEmail === 'Yes',
      isLabelBold: false,
    },
    {
      labelText: 'No',
      isDefault: data?.wantConfirmationEmail === 'No',
      isLabelBold: false,
    },
  ];

  return (
    <BinaryQuestionTemplate
      title={pageTitle}
      options={options}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      errorPath="receiveConfirmationEmail"
      errorMessages={errorMessages}
    />
  );
};
